module.exports = __webpack_public_path__ + "images/9c569a4fc79d04e738816762d4c824a9-IMG_8140.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_8140.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_8140.jpg
// module chunks = 0